import { ActiveModelSerializer } from 'active-model-adapter';

export default class ApplicationSerializer extends ActiveModelSerializer {}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    application: ApplicationSerializer;
  }
}
